

































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import AtendimentoAutocomplete from "@/components/saude/AtendimentoAutocomplete.vue";
import moment from "moment";
import {
  AtendimentoNotaFiscalDTO,
  ConfirmarComprovanteTransferenciaDTO,
  FiltroComprovanteTransferenciaDTO,
} from "@/api/cadastro/saude/ComprovanteTransferenciaDTO";
import { EspecialidadeDTO } from "@/api/cadastro/saude/EspecialidadeDTO";
import { tiposAtendimentoList } from "@/models/cadastros/saude/TipoAtendimentoModel";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import StatusContaPagarModel, { statusContaPagarList } from "@/models/commons/StatusContaPagarModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
    PrestadorAutocomplete,
    AtendimentoAutocomplete
  },
})
export default class ValidacaoTransferencia extends Vue {
  $refs!: {
    validacaoObserver: InstanceType<typeof ValidationObserver>;
    refuseReasonObserver: InstanceType<typeof ValidationObserver>;
  };

  listaStatus: StatusContaPagarModel[] = [
    { name: '', descricao: "Todos" },
    { name: 'APROVADO', descricao: 'Aprovado' },
    { name: 'REPROVADO', descricao: 'Reprovado' },
    { name: 'PENDENTE', descricao: 'Pendente' },
  ];

  today = moment().format("YYYY-MM-DD");
  loadingTable = false;
  filtro: FiltroComprovanteTransferenciaDTO = {
    dataInicialComprovanteEnviado: "",
    dataFinalComprovanteEnviado: "",
    status: undefined,
    cpfPaciente: undefined,
    idPrestador: undefined,
    page: 0,
    size: 5,
  };
  prestadorSelecionado = {} as PrestadorResumidoModel;
  atendimentoSelecionado = {};

  atendimentos: AtendimentoNotaFiscalDTO[] = [];

  cabecalho = [
    {
      text: "Data",
      value: "dataComprovanteDeTransferenciaBancaria",
      width: "5%",
      align: "center",
      divider: true,
    },
    {
      text: "Nª Atendimento",
      value: "numeroAtendimento",
      width: "10%",
      divider: true,
    },
    {
      text: "Atendimento",
      value: "descAtendimento",
      width: "25%",
      divider: true,
    },
    {
      text: "Preço Associado",
      value: "precoAssociado",
      width: "10%",
      divider: true,
    },
    {
      text: "Preço Prestador",
      value: "precoPrestador",
      width: "10%",
      divider: true,
    },
    {
      text: "Valor Adicional",
      value: "valorAdicionalPago",
      width: "10%",
      divider: true,
    },
    { text: "Status", value: "comprovanteTransferenciaBancariaAprovado", width: "15%", divider: true },
    {
      text: "Download Comprovante",
      value: "download",
      sortable: false,
      width: "5%",
      align: "center",
      divider: true,
    },
    {
      text: "Ações",
      value: "actions",
      sortable: false,
      width: "10%",
      divider: true,
    },
  ];
  tableOptions = {
    itemsPerPage: this.filtro.size,
    itemsLength: 0,
    page: this.filtro.page + 1,
  };

  // STATUS MODAL
  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  // CONFIRM MODAL
  showConfirmModal = false;
  confirmTitle = "";
  confirmMessage = "";

  idAtendimento: number = 0;
  motivoRecusa: string = "";

  @Watch("tableOptions.page")
  private listenTablePageChanges(): void {
    this.filtrar();
  }

  @Watch("tableOptions.itemsPerPage")
  private listenItemsPerPageChanges(): void {
    if (this.tableOptions.page === 1) {
      this.filtrar();
    } else {
      this.tableOptions.page = 1;
    }
  }

  public filtrar(): void {
  
    this.$refs.validacaoObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loadingTable = true;
        this.filtro.page = (this.tableOptions.page - 1);
        this.filtro.size = this.tableOptions.itemsPerPage;
        this.filtro.idPrestador = this.prestadorSelecionado.id;
        saudeAtendimentoService
          .pesquisarComprovantes(this.filtro)
          .then((res) => {
            this.atendimentos = res.content;
            this.tableOptions.itemsLength = res.totalElements;
            this.filtro = this.filtro = {
            dataInicialComprovanteEnviado: this.filtro.dataInicialComprovanteEnviado,
            dataFinalComprovanteEnviado: this.filtro.dataFinalComprovanteEnviado,
            status: undefined,
            cpfPaciente: undefined,
            idPrestador: undefined,
            page: 0,
            size: 5,
            };
          })
          .finally(() => this.loadingTable = false);
      }
    });
  }

  public downloadComprovante(nomeArquivo: string): void {
    this.loadingTable = true;
    saudeAtendimentoService
      .downloadComprovante(nomeArquivo)
      .then((res) => {
        const fileType = res.headers['content-type'].split(';')[0].split('/');
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;

        fileLink.setAttribute("download", `comprovante_${nomeArquivo}.${fileType[1]}`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingTable = false;
      })
      .catch((err) => {
        this.loadingTable = false;
        this.openDialog(
          "error",
          "Erro",
          "Não há arquivo de comprovante para download."
        );
      })
  }

  public recusarComprovante(idAtendimento: number, motivoRecusa: string): void {
    this.loadingTable = true;
    const payload: ConfirmarComprovanteTransferenciaDTO = {
      aprovado: false,
      idAtendimento,
      motivoRecusa,
    };
    saudeAtendimentoService
      .confirmarComprovante(payload)
      .then((resp) => this.filtrar())
      .catch((err) =>
        this.openDialog(
          "error",
          "Erro",
          "Falha ao validar comprovante de transferência! Por favor, entre em contato com o suporte."
        )
      )
      .finally(() => this.loadingTable = false);
  }

  public aprovarComprovante(idAtendimento: number): void {
    this.loadingTable = true;
    const payload: ConfirmarComprovanteTransferenciaDTO = {
      aprovado: true,
      idAtendimento,
    };
    saudeAtendimentoService
      .confirmarComprovante(payload)
      .then((resp) => this.filtrar())
      .catch((err) =>
        this.openDialog(
          "error",
          "Erro",
          "Falha ao validar comprovante de transferência! Por favor, entre em contato com o suporte."
        )
      )
      .finally(() => this.loadingTable = false);
  }

  public getDescAtendimento(row: EspecialidadeDTO): string {
    return `${
      tiposAtendimentoList.find(
        (atendimento) => atendimento.name === row.tipoAtendimento
      )?.descricao
    } - ${row.nome}`;
  }

  public getStatusDesc(status?: boolean): string {
    if (status != undefined || status != null) {
      return status ? 'Aprovado' : 'Reprovado';
    } else {
      return 'Pendente';
    }
  }

  public canValidate(status?: boolean): boolean {
    return this.getStatusDesc(status) == 'Pendente';
  }

  // MODAL
  public openRefuseModal(
    idAtendimento: number,
    msg?: string,
    title?: string
  ): void {
    this.idAtendimento = idAtendimento;
    this.confirmTitle = msg ?? "Recusar comprovante de transferência?";
    this.confirmMessage = title ?? "Informe o motivo da recusa.";
    this.showConfirmModal = true;
  }

  public refuseModalOnClose(yes: boolean): void {
    if (yes) {
      this.$refs.refuseReasonObserver.validate().then((valid) => {
        if (valid && !!this.idAtendimento) {
          this.recusarComprovante(this.idAtendimento, this.motivoRecusa);
          this.idAtendimento = 0;
          this.motivoRecusa = "";
          this.showConfirmModal = false;
        }
      });
    } else {
      this.showConfirmModal = false;
    }
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType || 'info'}.png`;
  }
}
